import { render } from "./shopSettings.vue?vue&type=template&id=3c2d610c&scoped=true"
import script from "./shopSettings.vue?vue&type=script&lang=js"
export * from "./shopSettings.vue?vue&type=script&lang=js"

import "./shopSettings.vue?vue&type=style&index=0&id=3c2d610c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2d610c"]])

export default __exports__